function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.00002 7.99998L7.00002 9.99998L10.5 5.5",
  fill: "none",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const Svg15Px = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(Svg15Px, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/15px.e60be5c2.svg";
export { ForwardRef as ReactComponent };